
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import VueKonva from 'vue-konva'
import strings from '@/assets/strings.json'
import PlusCircleOutlineIcon from 'vue-material-design-icons/PlusCircleOutline.vue'
import { Charm } from '@/models/Charm'
import { BaseDetail } from '@/interfaces/BaseDetail'
import Konva from 'konva'
import Gallery from '@/components/Gallery.vue'
import Image = Konva.Image;

Vue.use(VueKonva)

@Component({
  components: {
    Gallery,
    PlusCircleOutlineIcon
  }
})
export default class Composer extends Vue {
  @Prop() private base!: BaseDetail;
  @Prop() private charms!: Charm[];
  @Prop() private containerWidth!: number;
  @Prop() private onShowModal!: Function;

  private charmsImages: Image[] = []
  private baseImage: Image | null = null
  private composerStrings = strings.Step3.Composer;
  private stage!: Konva.Node

  private baseMaxSize = 800;
  private charmSize = 290;
  private charmRadius = this.charmSize / 2;

  get configKonva () {
    const scale = this.containerWidth / this.baseMaxSize
    return {
      width: this.containerWidth,
      height: this.containerWidth,
      scale: { x: scale, y: scale }
    }
  }

  refreshCharmsImages (charms: Array<Charm>) {
    this.charmsImages = []
    for (const charm of charms) {
      this.imageFromUrl(charm.image, (image: any) => {
        image.x = charm.x - this.charmRadius
        image.y = charm.y - this.charmRadius
        image.listening = false
        image.width = this.charmSize
        image.height = this.charmSize
        this.charmsImages.push(image)
      })
    }
  }

  @Watch('charms')
  onPropertyChanged (newCharms: Array<Charm>) {
    this.refreshCharmsImages(newCharms)
  }

  private imageFromUrl (url: string, callback: Function, anonymous = false) {
    const img = document.createElement('img')
    img.onload = function () {
      if (anonymous) img.setAttribute('crossOrigin', 'anonymous')
      const image = new Image({
        image: img
      })
      callback(image)
    }
    img.src = url
  }

  created () {
    this.imageFromUrl(this.base.image, (image: any) => {
      image.width = this.baseMaxSize
      image.height = this.baseMaxSize
      image.listening = false
      this.baseImage = image
    })

    if (this.charms.length > 0) {
      this.refreshCharmsImages(this.charms)
    }
  }

  mounted () {
    this.stage = (this.$refs.stage as any).getNode()
  }

  async showModal () {
    this.onShowModal()
  }
}
